import { Module, VuexModule } from "vuex-module-decorators";
import {
  MainMenuElements,
  GuardedElement,
  MainMenuElement,
} from "@/core/config/MainMenuConfig";

import {
  HeaderMenuElement,
  HeaderMenuElements,
} from "@/core/config/HeaderMenuConfig";
import {
  ActionBarElements,
  ActionElement,
} from "@/core/config/ActionBarConfig";
import { isUserRoleIn } from "@/core/services/UserRoleService";
import {
  FooterMenuElement,
  FooterMenuElements,
} from "@/core/config/FooterMenuConfig";
import {
  UserMenuElement,
  UserMenuElements,
} from "@/core/config/UserMenuConfig";

function filterMenu<E extends GuardedElement<E>>(
  elements: E[] | (() => E[])
): E[] {
  const filtered = [] as E[];
  if (typeof elements === "function") {
    elements = elements();
  }

  for (const i in elements) {
    const element = elements[i];
    if (element.isAllowed && !element.isAllowed()) {
      continue;
    }
    if (!isUserRoleIn(element.roles)) {
      continue;
    }
    if (element.sub) {
      element.sub = filterMenu(element.sub);
    }

    filtered.push(element);
  }

  return filtered;
}

// don't forget to wrap it up with computed(() => ...)
@Module
export default class MenusModule extends VuexModule {
  protected mainMenu = MainMenuElements;
  protected headerMenu = HeaderMenuElements;
  protected actionBarMenu = ActionBarElements;
  protected footerMenu = FooterMenuElements;
  protected userMenu = UserMenuElements;

  get getMainMenu(): GuardedElement<MainMenuElement>[] {
    return filterMenu(this.mainMenu);
  }
  get getHeaderMenu(): GuardedElement<HeaderMenuElement>[] {
    return filterMenu(this.headerMenu);
  }
  get getActionBarMenu(): GuardedElement<ActionElement>[] {
    return filterMenu(this.actionBarMenu);
  }
  get getFooterMenu(): GuardedElement<FooterMenuElement>[] {
    return filterMenu(this.footerMenu);
  }
  get getUserMenu(): GuardedElement<UserMenuElement>[] {
    return filterMenu(this.userMenu);
  }
}
